// extracted by mini-css-extract-plugin
module.exports = {"thankyouContainer":"Thankyou_thankyouContainer__3oFUh","imgContainer":"Thankyou_imgContainer__1_YH6","linebreak":"Thankyou_linebreak__3ZglU"};